import {
  CANCEL_EDITING_REQUEST,
  CANCEL_REQUEST,
} from '../../shared/actions/shared.actions'
import { FSA } from '../../shared/types'
import { RESET_BREAKDOWN_LOCATION } from '../location/location.actions'
import {
  ACKNOWLEDGE_NON_BLOCKING_ADVISORY,
  RESET_ADVISORIES,
  SERVICE_AVAILABILITY,
} from './advisories.actions'
import { ServiceAvailability } from './advisories.types'

export interface ServiceAvailabilityState {
  // Whether the user has acknowledged an informational advisory (Next in the
  // dialog). This is the sole flag displayAdvisories$ uses both to dedupe the
  // dialog and to decide whether to reopen it: while false, each new
  // SERVICE_AVAILABILITY.SUCCESS reopens the dialog; once true, it stays
  // deduped. Reset on RESET_ADVISORIES / cancel / breakdown location change so
  // a genuine location change re-shows the dialog and re-blocks navigation for
  // the new location.
  advisoryAcknowledged: boolean
  serviceAvailability?: ServiceAvailability
}

export const initialState: ServiceAvailabilityState = {
  serviceAvailability: null,
  advisoryAcknowledged: false,
}

export function reducer(
  state: ServiceAvailabilityState | undefined = initialState,
  action: FSA
): ServiceAvailabilityState {
  switch (action.type) {
    case SERVICE_AVAILABILITY.SUCCESS: {
      return {
        ...state,
        serviceAvailability: action.payload.serviceAvailability,
      }
    }
    case ACKNOWLEDGE_NON_BLOCKING_ADVISORY: {
      return {
        ...state,
        advisoryAcknowledged: true,
      }
    }
    // A genuine breakdown-location change (new address / home / GPS) invalidates
    // any advisory the user has already acknowledged for the previous location,
    // so the new location's response re-shows the dialog and re-gates navigation.
    case RESET_BREAKDOWN_LOCATION:
    case CANCEL_REQUEST:
    case CANCEL_EDITING_REQUEST:
    case RESET_ADVISORIES: {
      return {
        ...state,
        serviceAvailability: null,
        advisoryAcknowledged: false,
      }
    }
    default:
      return state
  }
}
